import { onMounted } from 'vue'
import { loadAppVersion, saveAppVersion } from '@/helpers/storage'

const VERSION_CHECK_INTERVAL = 60_000

export const useVersionCheck = (interval = VERSION_CHECK_INTERVAL) => {
  onMounted(() => {
    let initialCheckDone = false

    const checkVersion = async () => {
      try {
        const res = await fetch('/version.json', { cache: 'no-cache' })
        const { version: latestVersion } = await res.json()

        if (!initialCheckDone) {
          // 🧠 First check: always store version and trust current state
          saveAppVersion(latestVersion)
          initialCheckDone = true
          return
        }

        const storedVersion = loadAppVersion()
        if (storedVersion !== latestVersion) {
          saveAppVersion(latestVersion)
          window.location.reload()
        }
      } catch (err) {
        console.error('[version-check] Failed to fetch version.json:', err)
      }
    }

    checkVersion()
    setInterval(checkVersion, interval)
  })
}
